angular.module('pulse.fastClick', [])

.run(function() {
  FastClick.attach(document.body);
});
